export interface BreakpointMap {
    [name: string]: number;
}

export function getBreakpoints(): BreakpointMap {
    return {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
    };
}

export function getSize(width: number): "xs" | "sm" | "md" | "lg" | "xl" {
    if (width < getBreakpoints().sm) {
        return "xs";
    } else if (width < getBreakpoints().md) {
        return "sm";
    } else if (width < getBreakpoints().lg) {
        return "md";
    } else if (width < getBreakpoints().xl) {
        return "lg";
    }
    return "xl";
}

export function mapBreakpoints(width: number, map: BreakpointMap = getBreakpoints()): string[] {
    const breakpoints: string[] = [];
    Object.entries(map).forEach(([breakpoint, minWidth]) => {
        if (width >= minWidth) {
            breakpoints.push(breakpoint);
        }
    });
    return breakpoints;
}

export const getNextBreakPoint = (breakpoint: "xs" | "sm" | "md" | "lg") => {
    switch (breakpoint) {
        case "xs":
            return "sm";
        case "sm":
            return "md";
        case "md":
            return "lg";
        case "lg":
            return "xl";
    }
};
